import { useEffect, useState, useCallback } from "react";
import AdminShell from "../../components/AdminShell";
import { StatusBadge, TableWrapper } from "../../components/customer/CustomerUI";
import api from "../../lib/api";

export default function AccessCenter() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try { const { data } = await api.get("/admin/users"); setUsers(data); }
    catch (e) {} finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);


  return (
    <AdminShell title="User & Access Center" subtitle="Manage users, roles and account access">
      <div className="space-y-6">
        <div className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800">
          Customer Intelligence is dormant for launch. Credit grants and adjustments are disabled until the enrichment system is reactivated after revenue.
        </div>

        <TableWrapper title="All Users">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-300 text-left font-mono text-[10px] uppercase tracking-[0.12em] text-slate-500">
                <th className="px-4 py-3 font-medium">Name</th>
                <th className="px-4 py-3 font-medium">Email</th>
                <th className="px-4 py-3 font-medium">Role</th>
                <th className="px-4 py-3 font-medium">Provider</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={4} className="px-4 py-8 text-center text-slate-500">Loading users…</td></tr>
              ) : users.map((u) => (
                <tr key={u.user_id} data-testid={`admin-user-row-${u.user_id}`} className="border-b border-slate-300 last:border-0">
                  <td className="px-4 py-3 font-medium text-slate-900">{u.name}</td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-600">{u.email}</td>
                  <td className="px-4 py-3"><StatusBadge tone={u.role === "admin" ? "info" : "neutral"}>{u.role}</StatusBadge></td>
                  <td className="px-4 py-3 font-mono text-xs text-slate-500">{u.auth_provider}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableWrapper>
      </div>
    </AdminShell>
  );
}
